var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6166_7845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 2C11.3929 2 10.8424 2.36001 10.5986 2.91718L9.99761 4.29059C7.10735 5.1519 5 7.82985 5 11V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H10C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 17.5523 19 17V11C19 7.83226 16.8958 5.15597 14.009 4.29255L13.4023 2.91422C13.1578 2.35864 12.6081 2 12.0011 2ZM17.1707 18H6.82929C6.93985 17.6872 7 17.3506 7 17V11C7 8.23858 9.23858 6 12 6C14.7614 6 17 8.23858 17 11V17C17 17.3506 17.0602 17.6872 17.1707 18Z",
    fill: "#747B80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6166_7845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.fe8ee5ddd8efdd12ef02dd63d1807c78.svg";
export { ForwardRef as ReactComponent };